module.exports = __webpack_public_path__ + "static/media/sorting-light.54c5e3a2.svg";